import { getExhibitorsCopyText } from "lib/exhibitors/getExhibitorsCopyText"
import useCurrent from "lib/use-current"

export const useExhibitorCopyText = () => {
  const current = useCurrent()
  if (!current) return null
  return getExhibitorsCopyText(current)
}
